import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito ollas especiales?',
    a: 'No, con lo que tenés en casa (horno y 2 hornallas) alcanza perfectamente. El método está pensado para cocinas reales.'
  }, {
    q: '¿Es comida cara?',
    a: 'Al revés, está diseñada con precios de Argentina hoy. Al comprar con lista y aprovechar ingredientes de estación, vas a ahorrar un 40% respecto a lo que gastás hoy improvisando o pidiendo delivery.'
  }, {
    q: '¿Cuánto tiempo dura la comida?',
    a: 'Hasta 3 meses en el freezer, pero te la vas a comer antes por lo rica que es. Te enseñamos exactamente cómo guardar cada cosa para que mantenga su textura.'
  }];
  return <section className="py-20 px-6 bg-cream" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-serif text-forest font-bold mb-4" data-id="element-17">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl shadow-sm border border-sage overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-20">
                <span className="font-bold text-forest text-lg" data-id="element-21">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-22">
                  <ChevronDown className="w-5 h-5 text-terracotta" data-id="element-23" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-24">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-25">
                    <div className="px-6 pb-4 text-brown" data-id="element-26">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}